enum EstadosModalPlantillaImpresion {
    CERRADO = 'CERRADO',
    CREACION = 'CREACION',
    EDICION = 'EDICION',
    VISUALIZACION = 'VISUALIZACION',
}

export { EstadosModalPlantillaImpresion };
